import { render, staticRenderFns } from "./ParentList.vue?vue&type=template&id=000b6c9e"
import script from "../../controllers/parent/parent-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/parent/parent-list.js?vue&type=script&lang=js&external"
import style0 from "./ParentList.vue?vue&type=style&index=0&id=000b6c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports